import log from './log';

export interface GTMDataLayerData {
	order: {
		id: string;
		email: string;
		hashed_email: string;
		total: number;
		currency: string;
		couponCode: string;
		quantity: number;
		type: 'purchase' | 'rental';
	};
	geolocation: {
		city: string;
		state: string;
		commuting_zone_id: string;
	}
}

export function pushToDataLayer(data: DeepPartial<GTMDataLayerData>): void {
	try {
		const layer = window.dataLayer || [];

		const order = (data.order ?? {}) as Partial<GTMDataLayerData['order']>;
		const definedOrderValues: Partial<GTMDataLayerData['order']> = {};

		for (const key of Object.keys(order)) {
			const orderKey = key as keyof GTMDataLayerData['order'];
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(definedOrderValues as any)[orderKey] = order[orderKey] ?? '';
		}

		layer.push({ order: definedOrderValues, geolocation: data.geolocation });
	} catch (error) {
		if (error instanceof Error) {
			log.scope('GTM').warn(`Could not push to data layer: ${error.message}`);
		} else {
			log.scope('GTM').warn(`Could not push to data layer`, { error });
		}
	}
}
